package com.eladfinish.bible.contest.screens.search.usecases

import com.eladfinish.bible.contest.screens.search.model.SearchSuggestion

class GetPostSearchSuggestionsUseCase {

    operator fun invoke(
        originalExpression: String,
        resultsCount: Int,
    ): List<SearchSuggestion> =
        buildList {
            if (
                resultsCount == 0 &&
                originalExpression.matches(Regex(".+[וי].+"))
            ) {
                add(SearchSuggestion.OMIT_VAV_YUD)
            }
        }
}
